export default __webpack_public_path__ + "static/media/homePoster.03828335.png";